// extracted by mini-css-extract-plugin
export default {"root":"loading-module--root--WRgza","pulse":"loading-module--pulse--m8fkp"};